export const initiateLogin = async (email, language) => fetch(`${process.env.apiUrl}/v1/accounts/v2/initiate`, {
  method: 'post',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ email, language }),
});

export const getPersonalCounter = async (token) => fetch(`${process.env.apiUrl}/v1/accounts/v2/personal_counter?token=${token}`)
  .then((response) => response.json())
  .catch((error) => ({
    error,
  }));

export const refreshToken = async (token) => fetch(`${process.env.apiUrl}/v1/accounts/v2/refresh_token`,
  {
    body: JSON.stringify({
      token,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  },
)
  .then((response) => response.json())
  .catch((error) => ({
    error,
  }));
